var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "facebook",
    xmlnsXlink: "facebook",
    viewBox: "7795 599 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".afacebook{fill:none;}.bfacebook{clip-path:url(#cfacebookk);fill:#000;}.cfacebook{clip-path:url(#afacebookk);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "afacebookk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "afacebook",
    d: "M7695.408,527l-26.646,5.339s-20.224-3.817-22.56-20.916,1.147-46.254,1.147-46.254-.086-8.256,0-8.667c.295-1.489,9.84-13.86,26-14.785,17.12-.98,43.336.637,43.336.637s20.549,5.167,20.775,22.815.638,45.12.638,45.12l-7.775,19.119-21.812,3.514V496.257h10.269l1.508-12.357h-12.125v-9.514s-.058-4.293,5.4-4.119,7.251.29,7.251.29V459.417h-11.893s-13.17.116-13.286,13.053,0,11.429,0,11.429h-10.21v12.357h10.21Z",
    transform: "translate(0 114)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cfacebookk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7795,
    y: 599,
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bfacebookk",
    className: "bfacebook"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cfacebook",
    transform: "translate(142 38)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dfacebook",
    d: "M17,0H63A17,17,0,0,1,80,17V63A17,17,0,0,1,63,80H17A17,17,0,0,1,0,63V17A17,17,0,0,1,17,0Z",
    transform: "translate(7653 561)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.ddd288a84ef47fbf9084941600a7455a.svg";
export { ForwardRef as ReactComponent };